const name = 'BackgroundFadeIn';
const properties = {
    hideOnStart: false,
    getMaxTravel(elementMeasure, viewportHeight, siteHeight) {
        return Math.min(siteHeight - elementMeasure.top, (viewportHeight + elementMeasure.height) / 2, viewportHeight * 0.9);
    },
    groups: ['animation', 'background', 'legacy'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
    },
};
/**
 * Move balata media elements vertically (from y:0)
 */
function animate(kit, elements, duration, delay, params = {}) {
    const sequence = kit.sequence(params);
    sequence.add(kit.animate('BaseFade', elements, duration, delay, {
        from: { opacity: 0 },
        to: { opacity: 1 },
        ease: 'Circ.easeIn',
        force3D: true,
        immediateRender: true,
    }));
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=backgroundFadeIn.js.map